import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=32a9debd&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=32a9debd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a9debd",
  null
  
)

export default component.exports